import { render } from "./Home.vue?vue&type=template&id=8156510c"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=8156510c&lang=scss"

import exportComponent from "/Users/gj/Documents/projects/zwrtwt/zwit-planner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__